<template>
  <div class="page" :style="getBg()">
    <Header title="扫码签到" :show-back="false" />
    <div class="subject">{{ activityInfo.activityName }}</div>
    <!-- <div class="activity-img">
      <img :src="activityInfo.activityImageId ? this.getImageUrl(this.activityInfo.activityImageUri) : defaultImg">
    </div> -->
    <div class="content">
      <div class="input-row">
        <div class="icon-input icon-user"><img src="../../assets/images/qr-user.png"></div>
        <van-field v-model="authData.loginAccount" center clearable placeholder="请输入易加网账号" @blur="viewDefault"/>
      </div>
      <div class="input-row">
        <div class="icon-input icon-pwd"><img src="../../assets/images/qr-pwd.png"></div>
        <van-field v-model="authData.password" :type="passwordType" center clearable placeholder="请输入易加网密码" class="pwd-cell" @blur="viewDefault"/>
        <div class="icon-input icon-right" @click="switchPwd">
          <img v-if="passwordType" src="../../assets/images/qr-pwd-hide.png" class="pwd-hide">
          <img v-else src="../../assets/images/qr-pwd-show.png" class="pwd-show">
        </div>
      </div>

      <div class="button-line" @click="submitData">点 击 有 礼</div>
      <div class="operate text-right">
        <span @click="goRegister">还没有易加网账号？</span>
      </div>
      <div class="tips">
        <div><van-icon name="arrow" />此活动仅限 {{ getDate() }} 参与 </div>
        <div><van-icon name='arrow' />此活动仅限易加网指定渠道参加</div>
        <div><van-icon name="arrow" />新用户预注册7天内提交资料并激活账号可以领取奖励积分</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import { commonUtils, cryptoUtils } from '@/utils/common'
export default {
  name: 'ActivityQrSign',
  components: {
    Header
  },
  data () {
    return {
      activityInfo: {},
      authData: {
        activityId: '',
        loginAccount: '',
        password: ''
      },
      passwordType: 'password',
      bgHeight: ''
    }
  },
  computed: {
  },
  created () {
    this.init()
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,
    parseTime: commonUtils.parseTime,
    init () {
      this.authData.activityId = this.$route.params.activityId
      this.queryActivityInfo()
      this.bgHeight = (document.body.scrollHeight || document.documentElement.scrollHeight) - 46
    },
    queryActivityInfo () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载...'
      })
      this.$store.dispatch('getQrActivityInfo', this.authData.activityId).then(response => {
        this.activityInfo = response
        this.$toast.clear()
      }).then(() => {
        this.$toast.clear()
      })
    },
    getDate () {
      const startDate = this.parseTime(this.activityInfo.startDate, '{y}/{m}/{d}')
      const endDate = this.parseTime(this.activityInfo.endDate, '{y}/{m}/{d}')
      if (startDate === endDate) {
        return endDate
      }
      return startDate + ' - ' + endDate
    },
    getBg () {
      if (this.activityInfo.activityImageId) {
        return {
          background: '#fff url(' + this.getImageUrl(this.activityInfo.activityImageUri) + ') no-repeat center 40px',
          backgroundSize: 'cover',
          height: this.bgHeight + 'px'
        }
      }
      return {
        background: '#fff url(' + require('../../assets/images/activity-default.png') + ') no-repeat 0 40px',
        backgroundSize: 'contain',
        height: this.bgHeight + 'px'
      }
    },
    submitData () {
      // 时分秒
      const startDate = new Date(this.activityInfo.startDate)
      const endDate = new Date(this.activityInfo.endDate)
      const currentDate = new Date()
      if (currentDate > endDate) {
        this.$dialog.alert({ message: '活动已过期' })
        return false
      }
      if (currentDate < startDate) {
        this.$dialog.alert({ message: '活动于' + this.parseTime(this.activityInfo.startDate, '{y}/{m}/{d}') + '开始' })
        return false
      }
      if (!this.authData.loginAccount) {
        this.$dialog.alert({ message: '请填写您的易加网登录账号' })
        return false
      }
      if (!this.authData.password) {
        this.$dialog.alert({ message: '请填写您的易加网登录密码' })
        return false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '提交验证...'
      })
      this.authData.password = cryptoUtils.AESEncrypt(this.authData.password)
      activityApi.submitQrActivity(this.authData).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.$dialog.alert({
            title: '恭喜您',
            message: '获得' + this.activityInfo.pointValue + this.activityInfo.pointTypeName + '，点击确定返回易加网首页',
            confirmButtonText: '确定'
          }).then(() => {
            window.location.href = commonUtils.getExtraSite()
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    switchPwd () {
      this.passwordType = this.passwordType === 'password' ? '' : 'password'
    },
    goRegister () {
      this.$router.push({ name: 'activity-qr-sign-register', params: { activityId: this.authData.activityId } })
    },
    viewDefault () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100% - 46px);
  background: #fff;
}
.subject {
  text-align: center;
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;
  color: rgb(249, 127, 127);
  padding: 25px 0 15px;
}
.activity-img {
  width: 100%;
  height: 180px;
  margin-bottom: 25px;
  overflow: hidden;
  img {
    width: 100%;
    height: 180px;
  }
}
.content {
  width: 80%;
  margin: 0 auto;
}
.input-row {
  position: relative;
  height: 40px;
  border: 1px solid rgb(183, 202, 206);
  border-radius: 10px;
  margin-bottom: 20px;
  .icon-input {
    position: absolute;
    z-index: 10;
    top: 10px;
  }
  .icon-user {
    left: 10px;
    width: 18px;
    height: 18px;
    img {
      width: 18px;
      height: 18px;
    }
  }
  .icon-pwd {
    left: 10px;
    width: 15px;
    height: 18px;
    img {
      width: 15px;
      height: 18px;
    }
  }
  .icon-right {
    top: 14px;
    right: 10px;
    .pwd-hide {
      width: 18px;
      height: 8px;
    }
    .pwd-show {
      width: 16px;
      height: 10px;
    }
  }
  .van-cell {
    height: 40px;
    padding-left: 36px;
    border-radius: 20px;
  }
  .pwd-cell {
    padding-right: 36px;
  }
  ::-webkit-input-placeholder{
    color: rgb(183, 202, 206);
  }
}
.button-line {
  height: 40px;
  border-radius: 10px;
  margin: 30px 0 15px;
  background: rgb(52, 122, 127);
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
}
.operate {
  font-size: 12px;
  color: rgb(166, 166, 166);
}
.tips {
  padding: 22px 0;
  font-size: 12px;
  line-height: 24px;
  font-style: italic;
  .van-icon {
    position: relative;
    left: 0;
    top: 1px;
  }
}
</style>
